import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Input, notification, Row, Spin, Form } from 'antd';

import { useState } from 'react';
import { INVITE_MANAGER_SUCCESS } from '../../../constants/messages';
import { validateMessages } from '../../../constants/validation';
import assign from 'lodash/assign';
import { inviteStaff } from '../../../redux/actions/staffAction';

const AddManagerForm = ({ toggleAddManager, currentDepartmentId }) => {
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    setLoading(true);

    assign(values, { role: 4 });
    assign(values, { departments: [currentDepartmentId] });

    inviteStaff(values)
      .then((result) => {
        toggleAddManager();
        setLoading(false);
        notification.success({
          message: (INVITE_MANAGER_SUCCESS),
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <Spin spinning={loading}>
      <div className="add-drawer-content">
        <Row justify="space-between">
          <Col className="drawer-title">Invite Manager</Col>
          <Col>
            <CloseOutlined onClick={toggleAddManager} />
          </Col>
        </Row>
        <div className="add-drawer-form">
          <Form
            name="control-hooks"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            validateMessages={validateMessages}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter mail" />
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" type="primary" loading={loading}>
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Spin>
  );
};
export default AddManagerForm;
